

































































































































































































































































































































































































































































































































































import IInbound from '@/store/models/IInbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
import ICustomer from '@/store/models/ICustomer';
import IGood from '@/store/models/IGood';
import IListPalletType from '@/store/models/IListPalletType';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import Snackbar from '@/components/shared/Snackbar.vue';
import moment from 'moment';
import IInboundDetail from '@/store/models/IInboundDetail';
import IAuthentication from '@/store/models/IAuthentication';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import IListTypesInbounds from '../../../store/models/IListTypesInbounds';
import IListCurrency from '../../../store/models/IListCurrency';
import { ListInboundTypes } from '@/components/shared/ListInboundTypes';

@Component({
    components: {
        Snackbar
    }
})
export default class InboundSelector extends Vue {
    searchInbound: string = "";
    dialog: boolean = false;
    dialogStatus : boolean = false;
    isValid: boolean = true;
    isValidStatus: boolean = true;
    notificationText: string = "";
    sortBy: string = 'dateIn';
    sortDesc: boolean = true;
    showCompletedInbounds: boolean = false;
    selectedStartTime: number = 0;
    selectedEndTime: number = 0;
    settingsCompanyApi: SettingsCompanyApi;

    availableTimeSlotsLocal: number[] = [];

    headers: any = [
        { text: 'Company Source', align: 'start', value: 'companySourceName' },
        { text: 'Company Destination', value: 'companyDestinationName' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Arrival From', value: 'arrivalFrom' },
        { text: 'Arrival From Country', value: 'arrivalFromCountry' },
        { text: 'Dossier Number Source', value: 'code' },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Type', value: 'listTypesInboundsName' },
        { text: 'Estimated Time of Arrival', value: 'dateIn' },
        { text: 'Status', value: 'statusName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IInbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        containerNumber: "",
        sealNumber: "",
        weight: 0,
        liters: 0,
        referenceInboundCode: "",
        orderNumber: "",
        startTime: 0,
        endTime: 0,
        dateChanged: false,
        totalValue: 0,
        agp: "",
        arrivalFrom: "",
        codeDestination: "",
        idListTypesInbounds: "",
        listTypesInboundsName: "",
        idListCurrency: "",
        listCurrencyName: "",
        statusColor: "",
        arrivalFromCountry: ""
    }
    defaultItem : IInbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        containerNumber: "",
        sealNumber: "",
        weight: 0,
        liters: 0,
        referenceInboundCode: "",
        orderNumber: "",
        startTime: 0,
        endTime: 0,
        dateChanged: false,
        totalValue: 0,
        agp: "",
        arrivalFrom: "",
        codeDestination: "",
        idListTypesInbounds: "",
        listTypesInboundsName: "",
        idListCurrency: "",
        listCurrencyName: "",
        statusColor: "",
        arrivalFromCountry: ""
    }

    @Prop({ type: Array, required: true })
    InboundList !: IInbound[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    CustomerList !: ICustomer[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop({ type: Array, required: true })
    PalletTypesList !: IListPalletType[];
    @Prop({ type: Array, required: true })
    StatusInboundsList !: IListStatusInbound[];
    @Prop({ type: Array, required: true })
    TypesInboundsList !: IListTypesInbounds[];
    @Prop({ type: Boolean, default: false })
    loading !: boolean;
    @Prop()
    InboundCodeSelectedFromDashboard !: string;
    @Prop({ type: Array, required: true })
    AvailableTimeSlots !: Number[];
    @Prop()
    UserName !: string;
    @Prop()
    value !: IInbound;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInbounds !: boolean;
    @Prop({ type: Array, required: true })
    InboundDetailList !: IInboundDetail[];
    @Prop()
    CompanyId !: string;
    @Prop({ type: Boolean, default: false })
    IsStandAlone !: boolean;
    @Prop({ type: Boolean, default: false })
    HasLicensePlanning !: boolean;
    @Prop({ type: Array, required: true })
    CurrenciesList !: IListCurrency[];
    
    selectedInbound: IInbound[] = [];
    selectedCompanySource: ICompany = {} as ICompany;
    selectedCompanyDestination: ICompany = {} as ICompany;
    selectedCustomer: ICustomer = {} as ICustomer;
    selectedStatusInboundChange: IListStatusInbound | null = null;
    originalStatusId: string = "";
    originalStatusName: string = "";
    pendingNotificationText: string = "";
    selectedTypesInbound: IListTypesInbounds = {} as IListTypesInbounds;
    selectedCurrency: IListCurrency = {} as IListCurrency;
    dateIn: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    menu2: boolean = false;
    AvailableTimeSlotsEndTime: Number[] = [8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21];
    dialogDuplicate: boolean = false;
    inboundCodesToDuplicate: string [] = [];
    textInput: string = "";

    constructor() {
        super();
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        if (this.IsStandAlone) {
            this.selectedStartTime = 6;
            this.selectedEndTime = 7;
        }
    }

    @Watch('AvailableTimeSlots', { immediate: true, deep: true })
    onAvailableTimeSlotsChanged(val: Number[]) {
    // Si quisieras preservar un comportamiento especial en StandAlone, aquí puedes condicionarlo
        this.availableTimeSlotsLocal = (val || []).map(n => Number(n)).sort((a, b) => a - b);
    }

    private ensureSlotVisible(slot: number) {
        if (!slot) return;
        if (!this.availableTimeSlotsLocal.includes(slot)) {
            this.availableTimeSlotsLocal = [...this.availableTimeSlotsLocal, slot].sort((a, b) => a - b);
        }
    }

    get canEditInboundType(): boolean {
        const srcId =
            (this.selectedCompanySource && (this.selectedCompanySource as any).id)
                ? (this.selectedCompanySource as any).id
                : (this.editedItem && (this.editedItem as any).idCompanySource) || '';

        return !!this.CompanyId && srcId === this.CompanyId;
    }

    get isCurrentStatusExternal(): boolean {
        if (this.editedIndex === -1) return false;
        if (!this.editedItem || !this.editedItem.idStatus) return false;
        if (!this.StatusInboundsList || this.StatusInboundsList.length === 0) return true;
        return !this.StatusInboundsList.some(s => s.id === this.editedItem.idStatus);
    }

    get currentStatusHint(): string {
        if (this.isCurrentStatusExternal) {
            return "This status was set by another company. You can still change it to one of your company statuses.";
        }
        return "This is the current status. You can change it to another status defined in your company.";
    }

    get CanEdit() {
        return this.InboundDetailList.length > 0;
    }

    get date() {
        const today = new Date();
        const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
        return sixMonthsAgo.toISOString().substr(0, 10);
    }

    get orderNumberLabel(): string {
        const name = (this.selectedTypesInbound && this.selectedTypesInbound.name)
            ? this.selectedTypesInbound.name.toLowerCase()
            : '';

        if (name.includes(ListInboundTypes.Types.Entrepot) || name.includes(ListInboundTypes.Types.T1)) {
            return 'Entrepot Number';
        } else {
            return 'Order Number';
        }
    }

    get myCompany(): ICompany {
        return (this.CompanyList.find(c => c.id === this.CompanyId) || ({} as ICompany)) as ICompany;
    }

    get litersRules() {
        const typeName = (this.selectedTypesInbound && this.selectedTypesInbound.name)
            ? this.selectedTypesInbound.name.toLowerCase()
            : '';
        return (this.selectedCustomer &&
            this.selectedCustomer.requireInboundFields &&
            (typeName === ListInboundTypes.Types.Entrepot ||
            typeName === ListInboundTypes.Types.T1))
            ? [(v: any) => !!v || 'Liters is required']
            : [];
    }

    get totalValueRules() {
        const typeName = (this.selectedTypesInbound && this.selectedTypesInbound.name)
            ? this.selectedTypesInbound.name.toLowerCase()
            : '';
        return (this.selectedCustomer &&
            this.selectedCustomer.requireInboundFields &&
            (typeName === ListInboundTypes.Types.Entrepot ||
            typeName === ListInboundTypes.Types.T1))
            ? [(v: any) => !!v || 'Total Value is required']
            : [];
    }

    get currencyRules() {
        const typeName = (this.selectedTypesInbound && this.selectedTypesInbound.name)
            ? this.selectedTypesInbound.name.toLowerCase()
            : '';
        return (this.selectedCustomer &&
            this.selectedCustomer.requireInboundFields &&
            (typeName === ListInboundTypes.Types.Entrepot ||
            typeName === ListInboundTypes.Types.T1))
            ? [(v: any) => !!(v && (v as any).id) || 'Currency is required']
            : [];
    }

    get isReadOnlyMode(): boolean {
        // si no es editable globalmente, también debería quedar readonly
        const isCompleted = (this.editedItem && (this.editedItem.statusName || '').toLowerCase() === 'completed');
        return isCompleted && !this.CanModifyCompletedInbounds;
    }

    get orderNumberRules() {
        const typeName = (this.selectedTypesInbound && this.selectedTypesInbound.name)
            ? this.selectedTypesInbound.name.toLowerCase()
            : '';
        return (this.selectedCustomer &&
            this.selectedCustomer.requireInboundFields &&
            (typeName === ListInboundTypes.Types.Entrepot ||
            typeName === ListInboundTypes.Types.T1))
            ? [(v: string) => !!v || 'Entrepot Number is required']
            : [];
    }

    get currenciesForCompany(): IListCurrency[] {
        if (!this.CompanyId) return (this.CurrenciesList || []) as IListCurrency[];
        return (this.CurrenciesList || []).filter((c: any) => c.idCompany === this.CompanyId);
    }

    get canEditCurrency(): boolean {
        const src = (this.selectedCompanySource && (this.selectedCompanySource as any).id) ? (this.selectedCompanySource as any).id : '';
        const dst = (this.selectedCompanyDestination && (this.selectedCompanyDestination as any).id) ? (this.selectedCompanyDestination as any).id : '';

        const sourceIsMyCompany = src === this.CompanyId;
        const sameSourceAndDest = src !== '' && dst !== '' && src === dst;

        return sourceIsMyCompany || sameSourceAndDest;
    }

    get selectedCurrencyDisplay(): string {
        const sc: any = this.selectedCurrency as any;
        if (sc && sc.name) return sc.name;

        const ei: any = this.editedItem as any;
        return (ei && ei.listCurrencyName) ? ei.listCurrencyName : '';
    }

    get IsCompanySourceDifferentFromMyCompany(): boolean {
        return (
            this.selectedCompanySource &&
            (this.selectedCompanySource as any).id &&
            this.selectedCompanySource.id !== this.CompanyId
        );
    }

    private syncCurrencyByContext() {
        // Si no se puede editar, NO tocamos el currency (solo mostrar)
        if (!this.canEditCurrency) return;

        const list = this.currenciesForCompany;
        if (!list || list.length === 0) return;

        const selected: any = this.selectedCurrency as any;

        // Si el selectedCurrency no es de mi compañía, elegir EUR o el primero
        if (!selected || !selected.id || (this.CompanyId && selected.idCompany !== this.CompanyId)) {
            const eur = list.find(c => {
                const n = (c as any).name;
                return n && n.toLowerCase() === 'eur';
            });
            this.selectedCurrency = (eur || list[0]) as IListCurrency;
        }
    }

    @Watch('CompanyId', { immediate: true })
    onCompanyIdChanged() {
        this.selectedCompanySource = this.myCompany;
    }

    HasRightModifyCompletedInbounds() {
        if (this.showCompletedInbounds && !this.CanModifyCompletedInbounds) return false;
        return true;
    }

    get DateInFormatted(): string {
        return this.formatDate(this.dateIn) || '';
    }

    set DateInFormatted(value: string) {
    // Por si algún día quitas readonly o lo reutilizas
        const parsed = this.parseDate(value);
        if (parsed) this.dateIn = parsed;
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate(date: string) {
        if (!date) return null;

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Inbound' : 'Edit Inbound'; }

    @Watch('selectedCompanySource')
    onChangeSelectedCompanySource() {
        this.syncCurrencyByContext();
        this.$emit("loadTimeSlots", this.dateIn, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    @Watch('selectedCompanyDestination')
    onChangeSelectedCompanyDestination() {
        this.syncCurrencyByContext();
        this.$emit("loadTimeSlots", this.dateIn, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    @Watch('dateIn')
    onChangeDateIn() {
        const currentEditedDate = this.editedIndex > -1 ? this.convertDate(new Date(this.editedItem.dateIn)) : null;
        const dateChanged = this.editedIndex > -1 && currentEditedDate !== this.dateIn;

        if (dateChanged) {
            this.selectedStartTime = 0;
            this.selectedEndTime = 0;
        }

        this.$emit("loadTimeSlots", this.dateIn, dateChanged, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }
    
    @Watch('selectedStartTime')
    onChangeSelectedStartTime(newVal: number, oldVal: number) {
        if (!newVal || newVal === 0) return;

        // Si EndTime no está seleccionado, o quedó inválido, recalculamos
        if (!this.selectedEndTime || this.selectedEndTime === 0 || this.selectedEndTime <= newVal) {
            this.selectedEndTime = newVal + 1;
        }

    // (Opcional) Si quieres FORZAR siempre +1 al cambiar start:
    // this.selectedEndTime = newVal + 1;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('showCompletedInbounds')
    onChangeShowCompletedInbounds() {
        this.$emit('showCompletedInbounds', this.showCompletedInbounds);
    }

    @Watch('value')
    updateSelection(newValue : IInbound | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedInbound = [];
        } else {
            this.selectedInbound = [newValue];
            this.$emit('inboundChanged', this.selectedInbound[0]);
        }
    }

    get customersFiltered(): ICustomer[] {
        const srcId = (this.selectedCompanySource && (this.selectedCompanySource as any).id) ? (this.selectedCompanySource as any).id : '';
        return this.CustomerList.filter(c => c.idCompany === srcId) as ICustomer[];
    }

    @Watch('InboundCodeSelectedFromDashboard')
    onChangeInboundCodeSelectedFromDashboard() {
        this.searchInbound = this.InboundCodeSelectedFromDashboard;
    }

    @Watch('selectedStatusInboundChange')
    onChangeStatusInbound() {
        if (!this.selectedStatusInboundChange || !this.selectedStatusInboundChange.id) return;

        const newStatus = (this.selectedStatusInboundChange.name || '').toLowerCase();
        const currentStatus = ((this.editedItem.statusName || '') + '').toLowerCase();

        // ✅ No permitir Completed si no hay detalles
        if (newStatus === 'completed' && this.InboundDetailList.length === 0) {
            this.$emit('showMessageWarning', 'Cannot set status to Completed: inbound has no details.');

            // revertir selector
            const local = this.StatusInboundsList.find(s => (s.name || '').toLowerCase() === currentStatus);
            this.selectedStatusInboundChange = local || null;
            return;
        }

        // ✅ Notificación solo si cambia y no es Pending
        if (newStatus !== 'pending' && newStatus !== currentStatus) {
            this.notificationText = "";
            this.dialogStatus = true;
        }
    }

    private applyStatusIfValid() {
        if (!this.selectedStatusInboundChange || !this.selectedStatusInboundChange.id) return;

        const exists = this.StatusInboundsList && this.StatusInboundsList.some(s => s.id === this.selectedStatusInboundChange!.id);
        if (!exists) return;

        // ✅ Revalidación Completed sin details
        const newName = (this.selectedStatusInboundChange.name || '').toLowerCase();
        if (newName === 'completed' && this.InboundDetailList.length === 0) return;

        this.editedItem.idStatus = this.selectedStatusInboundChange.id;
        this.editedItem.statusName = this.selectedStatusInboundChange.name;
    }

    saveNotification() {
        const code = (this.editedItem && this.editedItem.code) ? this.editedItem.code : '';
        const statusName = (this.selectedStatusInboundChange && this.selectedStatusInboundChange.name)
            ? this.selectedStatusInboundChange.name
            : '';

        if (!statusName) {
            this.closeDialogStatus();
            return;
        }

        let msg = "";
        if (this.notificationText === "") {
            msg = `\n The user ${this.UserName} has changed the inbound ${code} to status ${statusName}`;
        } else {
            msg = `\n The user ${this.UserName} has changed the inbound ${code} to status ${statusName} Comment : ${this.notificationText}`;
        }

        // ✅ Guardar como pendiente para enviarlo solo si el save/edit va OK
        this.pendingNotificationText = msg;

        // ✅ Añadir al description para persistirlo
        this.editedItem.description += msg;

        this.closeDialogStatus();
    }

    ResetInbound() {
        if (this.IsStandAlone) {
            let index : number = this.CompanyList.findIndex(c => c.id === this.CompanyId);
            if (index !== -1) {
                this.selectedCompanySource = this.CompanyList[index];
                this.selectedCompanyDestination = this.CompanyList[index];
            }
            // ✅ NO mutar prop. Si quieres forzar un set local fijo:
            this.availableTimeSlotsLocal = [7, 8, 9, 10, 11, 13, 14, 15, 17, 18, 19, 20, 21];
            this.selectedStartTime = 7;
            this.selectedEndTime = 8;
        } else {
            this.selectedCompanySource = this.myCompany;
            this.selectedCompanyDestination = {} as ICompany;
            this.selectedStartTime = 0;
            this.selectedEndTime = 0;
        }
        
        const eur = this.currenciesForCompany.find(c => {
            const n = (c as any).name;
            return n && n.toLowerCase() === 'eur';
        });
        const list = this.currenciesForCompany;
        this.selectedCurrency = (eur || list[0] || ({} as IListCurrency)) as IListCurrency;
        this.syncCurrencyByContext();
        this.selectedCustomer = {} as ICustomer;
        this.selectedTypesInbound = this.TypesInboundsList.find(c => c.name.toLowerCase() === ListInboundTypes.Types.Vrij) as IListTypesInbounds;
        this.dateIn = new Date().toISOString().substr(0, 10);
        
        this.selectedStatusInboundChange = this.StatusInboundsList.find(c => c.name.toLowerCase() === "pending") as IListStatusInbound;
        // ✅ Pedir recalculo al padre (si hay destino)
        this.$emit("loadTimeSlots", this.dateIn, true, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);

        this.$emit('resetInbound');
    }

    editInbound (item: IInbound) {
        if (!item) return;
        this.selectedInbound = [item];
        this.$emit('input', item);
        this.editedIndex = this.InboundList.indexOf(item);
        if (item.startTime) {
            this.ensureSlotVisible(item.startTime);
        }
        const type = this.TypesInboundsList.find(c => c.id === item.idListTypesInbounds);
        if (type) {
            this.selectedTypesInbound = type as IListTypesInbounds;
        } else {
            this.selectedTypesInbound = {
                id: item.idListTypesInbounds,
                name: item.listTypesInboundsName
            } as IListTypesInbounds;
        }
        this.selectedCompanySource = this.CompanyList.find(c => c.id === item.idCompanySource) as ICompany || this.myCompany;
        this.selectedCompanyDestination = this.CompanyList.find(c => c.id === item.idCompanyDestination) as ICompany;
        let indexCurrency: number = this.CurrenciesList.findIndex(c => c.id === item.idListCurrency);
        if (indexCurrency !== -1) {
            this.selectedCurrency = this.CurrenciesList[indexCurrency];
        } else {
            indexCurrency = this.CurrenciesList.findIndex(c => c.name.toLowerCase() === 'eur');
            if (indexCurrency !== -1) {
                this.selectedCurrency = this.CurrenciesList[indexCurrency];
            }
        }
        this.selectedCustomer = this.CustomerList.find(c => c.id === item.idCustomer) as ICustomer;
        if (item.customerName === "") {
            this.selectedCustomer.name = "";
        }
        const local = this.StatusInboundsList.find(s => s.id === item.idStatus);
        this.selectedStatusInboundChange = local || null;

        // snapshot para revert (opcional si luego añades callback)
        this.originalStatusId = item.idStatus;
        this.originalStatusName = item.statusName;
        this.pendingNotificationText = "";
        this.selectedStartTime = item.startTime;
        this.selectedEndTime = item.endTime;
        this.dateIn = moment(new Date(item.dateIn)).format('YYYY-MM-DD');
        this.editedItem = Object.assign({}, item);
        this.syncCurrencyByContext();
        this.dialog = true;
        this.dialogStatus = false;
        // ✅ Recalcular slots para la fecha y destino actuales
        this.$emit("loadTimeSlots", this.dateIn, false, this.selectedCompanyDestination.id, this.selectedCompanySource.id, this.selectedStartTime);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    convertDate(date: Date) {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }

    async saveInbound() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.selectedCustomer !== undefined && Object.keys(this.selectedCustomer).length === 0) {
                this.$emit('showMessageWarning', 'Customer is required!');
            } else {
                let index = this.InboundList.findIndex(s => s.code === this.editedItem.code);
                let slot = 0;
                let canSave = true;
                if ((this.editedIndex > -1 && this.editedIndex !== index && index !== -1) || (this.editedIndex === -1 && index > -1)) {
                    canSave = false;
                } else if (this.selectedEndTime - this.selectedStartTime > 1) {
                    for (let i = this.selectedStartTime; i < this.selectedEndTime; i++) {
                        const countAtSlot = this.AvailableTimeSlots.filter(slot => slot === i).length;
                        if (countAtSlot >= 3) {
                            canSave = false;
                            slot = i;
                            break;
                        }
                    }
                } else if (this.selectedEndTime < this.selectedStartTime) {
                    canSave = false;
                } else if (this.editedItem.code === "") {
                    let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
                    let settingsCompany = SettingsCompany.Settings.GenerateCode;
                    let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingsCompany);
                    if (setting.length < 1) {
                        canSave = false;
                    } else {
                        canSave = true;
                    }
                }
                if (this.selectedCustomer.requireInboundFields && (this.selectedTypesInbound.name.toLowerCase() === ListInboundTypes.Types.Entrepot || this.selectedTypesInbound.name.toLowerCase() === ListInboundTypes.Types.T1)) {
                    const missingFields = [];

                    if (!this.editedItem.liters || this.editedItem.liters === 0) {
                        missingFields.push('Liters');
                    }

                    if (!this.editedItem.weight || this.editedItem.weight === 0) {
                        missingFields.push('Weight');
                    }

                    if (!this.editedItem.totalValue || this.editedItem.totalValue === 0) {
                        missingFields.push('Total Value');
                    }

                    if (!this.selectedCurrency || !this.selectedCurrency.id) {
                        missingFields.push('Currency');
                    }

                    if (!this.editedItem.orderNumber || this.editedItem.orderNumber.trim() === '') {
                        missingFields.push('Entrepot Number');
                    }

                    if (missingFields.length > 0) {
                        this.$emit('showMessageWarning', 'The following fields are required for this customer: ' + missingFields.join(', '));
                        return;
                    }
                }
                if (canSave) {
                    this.editedItem.idCompanySource = this.selectedCompanySource.id;
                    this.editedItem.idCompanyDestination = this.selectedCompanyDestination.id;
                    this.editedItem.companySourceName = this.selectedCompanySource.name;
                    this.editedItem.companyDestinationName = this.selectedCompanyDestination.name;
                    this.editedItem.idCustomer = this.selectedCustomer.id;
                    this.editedItem.customerName = this.selectedCustomer.name;
                    if (this.canEditInboundType) {
                        this.editedItem.idListTypesInbounds = this.selectedTypesInbound && this.selectedTypesInbound.id
                            ? this.selectedTypesInbound.id
                            : "";
                        this.editedItem.listTypesInboundsName = this.selectedTypesInbound && this.selectedTypesInbound.name
                            ? this.selectedTypesInbound.name
                            : "";
                    }
                    this.editedItem.idListCurrency = this.selectedCurrency.id;
                    this.editedItem.listCurrencyName = this.selectedCurrency.name;
                    if (this.editedIndex > -1) {
                        this.applyStatusIfValid();
                    } else {
                        // ✅ NEW: status requerido
                        if (!this.selectedStatusInboundChange || !this.selectedStatusInboundChange.id) {
                            this.$emit('showMessageWarning', 'Status is required');
                            return;
                        }
                        this.editedItem.idStatus = this.selectedStatusInboundChange.id;
                        this.editedItem.statusName = this.selectedStatusInboundChange.name;
                    }
                    let date = this.convertDate(new Date(this.editedItem.dateIn));
                    if (date !== this.dateIn && this.editedIndex > -1) {
                        this.editedItem.dateChanged = true;
                    }
                    this.editedItem.dateIn = new Date(this.dateIn);
                    this.editedItem.startTime = this.selectedStartTime;
                    this.editedItem.endTime = this.selectedEndTime;
                    if (this.editedItem.referenceInboundCode === null) {
                        this.editedItem.referenceInboundCode = "";
                    }
                    if (this.editedIndex > -1) {
                        this.$emit('editInbound', this.editedItem);
                    } else {
                        this.$emit('saveInbound', this.editedItem);
                    }
                    this.close();
                } else {
                    if (slot === 12) {
                        this.$emit('showMessageWarning', 'The 12-13 timeslot is reserved for the break. Select another timeslot.');
                    } else if (slot > 0) {
                        this.$emit('showMessageWarning', `The selected timeslot from ${this.selectedStartTime} to ${this.selectedEndTime} exceeds the limit of 3 in/outbounds for hour ${slot}. Please choose another range.`);
                    } else if (this.selectedStartTime > this.selectedEndTime) {
                        this.$emit('showMessageWarning', 'The end time cannot be less than the start time. Please select another time slot for the end time.');
                    } else if (this.editedItem.code === "") {
                        this.$emit('showMessageWarning', 'The dossier number is required. Please fill the dossier number.');
                    } else {
                        this.$emit('showMessageWarning', 'This order number ' + this.editedItem.code + ' is already in use. Duplicate order numbers cannot be used.');
                    }
                }
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }
    
    deleteInbound(inbound: IInbound) {
        if (!inbound) return;
        this.selectedInbound = [inbound];
        this.$emit('input', inbound);
        this.$emit('deleteInbound', inbound);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    closeDialogStatus() : void {
        this.dialogStatus = false;
        this.$nextTick(() => {
            this.notificationText = "";
        });
    }

    select(item: IInbound): void {
        const isSame = this.selectedInbound.length === 1 && this.selectedInbound[0].id === item.id;
        if (isSame) {
            this.selectedInbound = [];
            this.$emit('input', null);
            return;
        }

        this.selectedInbound = [item];
        this.$emit('input', item);
    }

    // ==============================
    //  DUPLICATE INBOUND METHODS
    // ==============================

    openDuplicateDialog() {
        // 🔥 Limpiar lista cada vez que se abre el diálogo
        this.inboundCodesToDuplicate = [];
        this.textInput = "";
        this.dialogDuplicate = true;
    }

    cancelDuplicateDialog() {
        // Cierra y limpia
        this.dialogDuplicate = false;
        this.inboundCodesToDuplicate = [];
        this.textInput = "";
    }

    submitInboundCode() {
        const value = this.textInput.trim();

        if (!value) {
            this.$emit('showMessageWarning', 'Please enter a dossier number');
            return;
        }

        if (this.inboundCodesToDuplicate.includes(value)) {
            this.$emit('showMessageWarning', 'This dossier number already exists in the list');
            return;
        }

        this.inboundCodesToDuplicate.push(value);
        this.textInput = "";
    }

    deleteInboundCodeToDuplicate(item: string) {
        this.inboundCodesToDuplicate = this.inboundCodesToDuplicate.filter(v => v !== item);
    }

    duplicateInbound() {
        let duplicatedExisting: string[] = [];

        // Validar si alguno de los códigos ya existe en el sistema
        for (const code of this.inboundCodesToDuplicate) {
            const exists = this.InboundList.some(i => i.code === code);
            if (exists) {
                duplicatedExisting.push(code);
            }
        }

        if (duplicatedExisting.length > 0) {
            this.$emit(
                'showMessageWarning',
                `These dossier numbers already exist: ${duplicatedExisting.join(", ")}`
            );
            return;
        }

        // Emitir duplicados nuevos
        for (const code of this.inboundCodesToDuplicate) {
            this.$emit('duplicateInbound', code);
        }

        // 🔥 Limpiar después de duplicar
        this.inboundCodesToDuplicate = [];
        this.textInput = "";

        // Cerrar diálogo
        this.dialogDuplicate = false;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
